<template>
  <div>
    <noscript>
      <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-WX9QHHQX"
      height="0"
      width="0"
      style="display:none;visibility:hidden">
      </iframe>
    </noscript>
    <h3>Criando conta para a empresa</h3>
    <p>Preenchendo os dados abaixo, em poucos minutos você e sua equipe já estarão prontos para ligar.</p>
    <form
      ref="signupForm"
      novalidate
      @submit.prevent="onSubmit"
      @keydown.enter.prevent="onSubmit">
      <ErrorAlert :error="error" />
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-user" />
          </div>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            ref="name"
            placeholder="Nome completo"
            minlength="2"
            maxlength="128"
            v-model="name"
            @blur="validateName"
            @input="errors.name = null"
            required
            autofocus>
        </div>
        <div
          v-if="errors.name"
          class="field-error">{{ errors.name }}</div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-home" />
          </div>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.organizationName }"
            ref="organizationName"
            placeholder="Nome da sua empresa"
            minlength="2"
            maxlength="128"
            v-model="organizationName"
            @blur="validateOrganizationName"
            @input="errors.organizationName = null"
            required>
        </div>
        <div
          v-if="errors.organizationName"
          class="field-error">{{ errors.organizationName }}</div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-mail" />
          </div>
          <input
            type="email"
            class="form-control"
            :class="{ 'is-invalid': errors.email }"
            placeholder="E-mail corporativo"
            maxlength="128"
            v-model="email"
            @blur="validateEmail"
            @input="errors.email = null"
            required>
        </div>
        <div
          v-if="errors.email"
          class="field-error">{{ errors.email }}</div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            :type="passwordVisible ? 'text' : 'password'"
            class="form-control"
            :class="{ 'is-invalid': errors.password }"
            placeholder="Crie uma senha"
            maxlength="128"
            v-model="password"
            @blur="validatePassword"
            @input="errors.password = null"
            required>
          <span class="input-group-append">
            <a
              class="input-group-text"
              href="#"
              @click.prevent="passwordVisible = !passwordVisible">
              <i :class="passwordVisible ? 'ik ik-eye-off' : 'ik ik-eye'" />
            </a>
          </span>
        </div>
        <div
          v-if="errors.password"
          class="field-error">{{ errors.password }}</div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-phone" />
          </div>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.phone }"
            placeholder="Celular com DDD — (11) 99999-9999"
            maxlength="15"
            v-model="phoneDisplay"
            @keydown="allowOnlyNumericKeydown"
            @blur="validatePhoneField"
            @input="errors.phone = null"
            required>
        </div>
        <div
          v-if="errors.phone"
          class="field-error">{{ errors.phone }}</div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-users" />
          </div>
          <input
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errors.userQuantity }"
            placeholder="Número de vendedores no time comercial"
            min="1"
            max="2000"
            step="1"
            v-model.number="userQuantity"
            @keydown="blockNonInteger"
            @blur="validateUserQuantity"
            @input="errors.userQuantity = null"
            required>
        </div>
        <div
          v-if="errors.userQuantity"
          class="field-error">{{ errors.userQuantity }}</div>
      </div>
      <div class="form-group">
        <small class="text-muted">
          Ao criar sua conta, você concorda com nossos
          <a href="https://www.api4com.com/terms-of-service" target="_blank" rel="noopener noreferrer">Termos de Uso</a>
          e
          <a href="https://www.api4com.com/privacy-policy" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>.
        </small>
      </div>
      <div class="buttons">
        <button
          class="btn btn-outline-secondary"
          @click.prevent="onCancel">Voltar</button>
        <button
          type="submit"
          ref="submitButton"
          class="btn btn-primary">Criar conta da empresa</button>
      </div>
      <div class="login-shortcut">
        <p>
          Sua empresa já possui conta API4COM?
          Faça login
          <a
            href="#"
            class="login-link"
            @click.prevent="goToLogin">aqui</a>.
        </p>
      </div>
    </form>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="signupSuccess"
      ref="signupSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sua conta foi criada com sucesso!</h5>
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-warning">Porém ainda temos mais um passo para finalizar o cadastro, por favor verifique seu e-mail e clique no link de verificação antes de fazer o seu primeiro login.</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="onModalOk">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPhoneMask, phoneDigitsOnly, allowOnlyNumericKeydown } from '@/utils/phone'
import { executeRecaptcha } from '@/services/recaptcha'
import signupVoucher from '@/services/signup-voucher'
import signupAttribution from '@/services/signup-attribution'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const DOMAIN_PREFIX_MIN_LENGTH = 3
const MIN_USER_QUANTITY = 1
const MAX_USER_QUANTITY = 2000

const slugifyDomain = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]/g, '')

export default {
  name: 'OrganizationSignup',
  data () {
    return {
      name: null,
      organizationName: null,
      email: null,
      password: null,
      phone: null,
      userQuantity: null,
      passwordVisible: false,
      submitting: false,
      voucherCode: signupVoucher.resolve(this.$route.query.voucher),
      attribution: signupAttribution.resolve(this.$route.query),
      error: null,
      errors: {
        name: null,
        organizationName: null,
        email: null,
        password: null,
        phone: null,
        userQuantity: null
      }
    }
  },
  computed: {
    phoneDisplay: {
      get () {
        return formatPhoneMask(this.phone || '')
      },
      set (value) {
        this.phone = phoneDigitsOnly(value)
      }
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.addGoogleTag()
    })
  },
  methods: {
    allowOnlyNumericKeydown,
    blockNonInteger (event) {
      if (['.', ',', 'e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault()
      }
    },
    addGoogleTag () {
      if (!document.getElementById('google-tag-manager')) {
        const script = document.createElement('script')
        script.id = 'google-tag-manager'
        script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-WX9QHHQX');
        `
        document.head.appendChild(script)
      }
    },
    validateName () {
      const valid = this.name && this.name.trim().length >= 2
      this.errors.name = valid ? null : 'Informe seu nome completo'
      return !this.errors.name
    },
    validateOrganizationName () {
      const value = (this.organizationName || '').trim()
      if (value.length < 2) {
        this.errors.organizationName = 'Informe o nome da sua empresa'
      } else if (slugifyDomain(value).length < DOMAIN_PREFIX_MIN_LENGTH) {
        this.errors.organizationName = `Use ao menos ${DOMAIN_PREFIX_MIN_LENGTH} letras ou números no nome da empresa`
      } else {
        this.errors.organizationName = null
      }
      return !this.errors.organizationName
    },
    validateEmail () {
      const valid = this.email && EMAIL_REGEX.test(this.email.trim())
      this.errors.email = valid ? null : 'Digite um e-mail válido (ex: nome@empresa.com)'
      return !this.errors.email
    },
    validatePassword () {
      this.errors.password = this.password ? null : 'Crie uma senha'
      return !this.errors.password
    },
    validatePhoneField () {
      const digits = phoneDigitsOnly(this.phone)
      const isValid = digits.length === 10 || digits.length === 11
      this.errors.phone = isValid ? null : 'Informe um celular com DDD válido (ex: (11) 99999-9999)'
      return !this.errors.phone
    },
    validateUserQuantity () {
      const quantity = this.userQuantity
      const isValid = Number.isInteger(quantity) && quantity >= MIN_USER_QUANTITY && quantity <= MAX_USER_QUANTITY
      this.errors.userQuantity = isValid ? null : `Informe um número entre ${MIN_USER_QUANTITY} e ${MAX_USER_QUANTITY}`
      return !this.errors.userQuantity
    },
    validateAll () {
      const validations = [
        this.validateName(),
        this.validateOrganizationName(),
        this.validateEmail(),
        this.validatePassword(),
        this.validatePhoneField(),
        this.validateUserQuantity()
      ]
      return validations.every(Boolean)
    },
    onSubmit () {
      if (this.submitting) return
      this.error = null
      if (!this.validateAll()) return
      this.submitting = true
      this.$refs.submitButton.disabled = true
      executeRecaptcha('signup')
        .then(recaptchaToken => {
          const payload = {
            name: this.name.trim(),
            organizationName: this.organizationName.trim(),
            password: this.password,
            email: this.email,
            phone: this.phone,
            userQuantity: this.userQuantity,
            voucherCode: this.voucherCode,
            attribution: this.attribution,
            redirect: this.$route.params.redirect,
            recaptchaToken
          }
          const campaignId = this.getQueryParamCaseInsensitive(this.$route.query, 'campaignId')
          if (campaignId) {
            payload.campaignId = campaignId
          }
          return this.$store.dispatch('auth/signUp', payload)
        })
        .then(_ => {
          signupVoucher.clear()
          signupAttribution.clear()
          $(this.$refs.signupSuccess).modal('show')
        })
        .catch(err => {
          this.showErrors(err)
        })
        .finally(() => {
          this.submitting = false
          this.$refs.submitButton.disabled = false
        })
    },
    getQueryParamCaseInsensitive (query, param) {
      const lowerParam = param.toLowerCase()
      const matchingKeys = Object.keys(query).filter(k => k.toLowerCase() === lowerParam)
      return matchingKeys.length > 0 ? query[matchingKeys[0]] : null
    },
    showErrors (error) {
      // TEL-2243: mesmo generico do mapa (utils/error-message.js).
      this.error = { message: 'Não conseguimos processar sua solicitação no momento. Tente novamente em alguns minutos ou fale com o suporte: (48) 3332-8503.' }
      if (error) {
        if (['RECAPTCHA_TOKEN_REQUIRED', 'RECAPTCHA_TOKEN_INVALID', 'RECAPTCHA_SCORE_TOO_LOW', 'RECAPTCHA_ACTION_MISMATCH'].includes(error.code)) {
          this.error = { message: 'Falha na verificação anti-robô. Recarregue a página e tente novamente.' }
        } else if (error.statusCode === 502) {
          this.error = { message: 'Ocorreu um erro ao tentar criar a conta, por favor entre em contato com nosso suporte pelo WhatsApp (48) 3332-8503' }
        } else if (error.message) {
          if (error.message.includes('Email already exists')) {
            this.error = { message: 'Email já cadastrado, por favor informe outro ou recupere a senha' }
          } else if (error.message.includes('Email inválido')) {
            this.error = { message: 'Email inválido, por favor informe um email válido' }
          } else if (error.message.startsWith('cannot create organization')) {
            this.error = { message: 'Não foi possível criar a conta, por favor entre em contato com nosso suporte pelo WhatsApp (48) 3332-8503' }
          } else if (error.message.includes('Nome da empresa não permite gerar um domínio válido')) {
            this.error = { message: `Use ao menos ${DOMAIN_PREFIX_MIN_LENGTH} letras ou números no nome da empresa` }
          } else if (error.message.includes('Não foi possível gerar um domínio único')) {
            this.error = { message: 'Não foi possível criar a conta com esse nome de empresa, tente uma variação ou entre em contato com nosso suporte pelo WhatsApp (48) 3332-8503' }
          } else if (error.friendly && Array.isArray(error.friendly.lines) &&
            error.friendly.code !== 'UNKNOWN') {
            // TEL-2243: o normalizador ja resolve `details.messages` — mantem em pt-BR
            // o que o backend manda traduzido e nomeia o campo quando nao ha texto
            // proprio. Montar `lines` daqui devolvia o texto do LoopBack em ingles.
            this.error = error.friendly
          }
        }
      } else {
        this.error = { message: 'Não conseguimos processar sua solicitação no momento. Tente novamente em alguns minutos ou fale com o suporte: (48) 3332-8503.' }
      }
    },
    onModalOk () {
      $(this.$refs.signupSuccess).modal('hide')
      this.$router.push(this.$route.params.redirect || {name: 'login'})
    },
    onCancel () {
      this.$router.go(-1)
    },
    goToLogin () {
      this.$router.push({ name: 'login', query: this.$route.query })
    }
  },
  watch: {
    email: function (value) {
      this.email = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.signup {
  display: flex;
  height: 100vh;
}
.card {
  margin: auto;
  max-width: 650px;
}
.input-group {
  margin-bottom: 0;
}
.custom-select {
  color: #818b91;
}
.field-error {
  display: block;
  margin-top: 4px;
  color: #dc3545;
  font-size: 12px;
  line-height: 1.2;
}
.login-shortcut {
  margin-top: 16px;
  text-align: center;

  p {
    margin-bottom: 0;
    color: #818b91;
    font-size: 13px;
  }

  .login-link {
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/Signup.vue